<template>
  <div class="flex flex-row justify-between items-center gap-2 font-rubik">
    <a :href="`tel:${organizationPhone || phoneNumber}`">
      <button
        class="phone-button border rounded-full flex items-center justify-center" 
      >
        <img
          class=""
          src="@/images/header/phone.svg"
          alt="Contact us"
        />
      </button>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    organizationPhone: String,
    phoneNumber: String 
  }
}
</script>

<style scoped>
  .phone-button {
    width: 40px;
    height: 40px;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: -0.04em;
    background-color: #ffffff;
    border: 1px solid #3565FC;
  }
</style>